import { osName } from "react-device-detect"

import { sessionStorageKeys } from "@/constants/storageKeys"

export const isChromebook = osName === "Chromium OS"

// Function to check if the app is running as a PWA on a Chromebook
export function isPWAOnChromebook() {
  const isPWA = window.matchMedia("(display-mode: standalone)").matches
  const flag = sessionStorage.getItem(sessionStorageKeys.CHROME_APP)
  return flag === "true" || (isChromebook && isPWA)
}
